import React, { Fragment } from 'react'
import SliderSlick from 'react-slick'
import { Button } from 'react-bootstrap'

import './VisionWidget.scss'

const VisionWidget = ({ data }) => {

  const sliderSettings = {
    dots: false,
    arrows: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    touchMove: true,
    prevArrow: <Button><i className='fa fa-angle-left fa-lg' /></Button>,
    nextArrow: <Button><i className='fa fa-angle-right fa-lg' /></Button>,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 1, dots: true } },
    ]
  }

  const renderSlides = () => {
    const slides = data.map((item) => ([{text: item.title, img: item.img}, {text: item.text}])).flat()
    console.log('slides ', slides)
    return slides.map((slide, key) => (
        <div key={key} className={'slider-vision-item'}>
          <div className={`slider-vision-item-content ${slide.img ? 'with-img' : ''}`}>
            {slide.img && <img src={slide.img} />}
            {slide.text}
          </div>
        </div>
      )
    )
  }

  const renderDesktopSlides = () => {
    const slides = data.map((item) => ({title: item.title, text: item.text, img: item.img}))
    console.log('slides ', slides)
    return slides.map((slide, key) => (
        <div key={key} className={'slider-vision-item'}>
          <div className='flip-card'>
            <div className='flip-card-inner'>
              <div className='flip-card-front'>
                <div className={'slider-vision-item-content with-img'}>
                  <img src={slide.img} style={{height: '110px', width: 'auto'}} />
                  {slide.title}
                </div>
              </div>
              <div className='flip-card-back'>
                <div className={'slider-vision-item-content'}>
                  <p>{slide.text}</p>
                </div>
              </div>
            </div>
          </div>
          {/* <div className='slider-vision-item-content with-img'>
            <h3>{slide.title}</h3>
            {slide.img && <img src={slide.img} />}
            {slide.text}
          </div> */}
        </div>
      )
    )
  }

  return <Fragment>
    <div className='slider-vision visible-xs'>
      <SliderSlick className='slider-vision-container' {...sliderSettings}>
        {renderSlides()}
      </SliderSlick>
    </div>
    <div className='slider-vision hidden-xs'>
      <SliderSlick className='slider-vision-container' {...sliderSettings}>
        {renderDesktopSlides()}
      </SliderSlick>
    </div>
  </Fragment>
}

export {
  VisionWidget,
}



// WEBPACK FOOTER //
// ./src/features/PageCompany/Components/VisionWidget/VisionWidget.component.js